export default __webpack_public_path__ + "static/media/logo-vertical-blue.b8158dfe.svg";